import { useTheme } from '@mui/material/styles';
import {
	Grid,
	Card,
	CardContent,
	IconButton,
	useMediaQuery,
	Divider,
	Button,
	Typography,
	Box,
	List,
	Avatar,
	ImageList,
	ImageListItem,
	ListItem,
	ListItemText,
	ListItemAvatar,
	CardActions,
	ToggleButtonGroup,
	ToggleButton,
	Skeleton,
	TextField,
	Checkbox,
	CircularProgress,
	FormHelperText,
	FormHelperTextProps,
	FormGroup,
	FormControlLabel,
	FormControl,
	OutlinedInput,
	InputAdornment,
	LinearProgress,
	MenuItem,
} from '@mui/material';

import { useTranslation } from 'react-i18next';

import clientMD from '~/content/svg/clients/mde.webp';
import website_hero_md_app from '~/content/images/references/md-app/md-dashboard-home.webp';
// import LaptopSkeletonIllustration from "~/content/svg/illustrations/LaptopSkeleton";

const Hero = (): JSX.Element => {
	let { t } = useTranslation(['project_md-app']);
	const theme = useTheme();
	const { mode } = theme.palette;
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true,
	});

	const LeftSide = () => (
		<Box>
			<Box marginBottom={2}>
				<Typography component={'h1'} variant='h4' sx={{ fontWeight: 700 }}>
					{t('hero_headline')}
				</Typography>
			</Box>
			<Typography variant={isMd ? 'subtitle1' : 'body1'} component='p' color='text.secondary'>
				{t('hero_description')}
			</Typography>
			<Box marginTop={1}>
				<Box
					boxShadow={0}
					width={1}
					height={1}
					display={'flex'}
					flexDirection={'column'}
					bgcolor={theme.palette.background.default}
				>
					<CardContent
						sx={{
							display: 'flex',
							flexDirection: 'column',
						}}
					></CardContent>
					<CardActions sx={{ paddingBottom: 1 }}>
						<ListItem component='div' disableGutters sx={{ padding: 0 }}>
							<Box
								sx={{
									filter: mode === 'dark' ? 'brightness(0) invert(1)' : 'none',
								}}
								component={'img'}
								src={clientMD}
								maxWidth={{ xs: 65, sm: 65, md: 70 }}
								alt='Logo von MD Elektronik GmbH'
							/>
							<ListItemText
								sx={{ margin: 0, marginLeft: 3 }}
								primary={t('hero_customer')}
								secondary={t('hero_service')}
							/>
						</ListItem>
					</CardActions>
				</Box>
			</Box>
		</Box>
	);

	return (
		<Grid container spacing={4}>
			<Grid item container alignItems={'center'} xs={12} md={6}>
				<Box>
					<LeftSide />
				</Box>
			</Grid>
			<Grid item container alignItems={'center'} xs={12} md={6}>
				<Box width={1}>
					<Box
						sx={{
							maxWidth: isMd ? '100%' : '550px',
							position: 'relative',
							marginX: 'auto',
						}}
					>
						<Box
							component={'img'}
							src={website_hero_md_app}
							alt='Bild einer individuell erstellten Softwareanwendung für einen Kunden in Deutschland'
							width={1}
							height={1}
							sx={{
								// objectFit: "cover",
								filter: theme.palette.mode === 'dark' ? 'brightness(0.9)' : 'none',
							}}
						/>
					</Box>
				</Box>
			</Grid>
		</Grid>
	);
};

export default Hero;
